import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { PageName } from '@/enums/pageName'
import { downloadImage } from '@/utils/imageUtils'
import { getPageName } from '@/utils/urlUtils'

import { Less } from '@/shared/icons/Less'
import { logo, logoLarge } from '@/shared/images/dogo'

import { TProgressBarProps } from './types'

const logoDogo = downloadImage(logo)
const logoDogoLarge = downloadImage(logoLarge)

export const ProgressBarDogo = ({ pagesConfig, pageOrder }: TProgressBarProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const totalStep = useMemo<number>((): number => {
    let counter = 0
    for (const pageName in pagesConfig) {
      const pageConfig = pagesConfig[pageName as PageName]
      if (pageConfig && pageConfig.hasOwnProperty('progress')) {
        ++counter
      }
    }
    return counter
  }, [pagesConfig])
  const pageName = getPageName(location.pathname)
  const currentPageConfig = pagesConfig[pageName]

  const back = () => {
    navigate(-1)
  }

  const paymentScreenPage = pageName === PageName.paymentScreen
  const isShow = !paymentScreenPage && currentPageConfig && currentPageConfig.pageNumber
  const isFirstPage = pageName === pageOrder?.[0]

  const showBack = Boolean(paymentScreenPage || (isShow && !isFirstPage))
  const currentLogo = pageName === PageName.selectPlan ? logoDogoLarge : logoDogo
  const logoWidth = pageName === PageName.selectPlan ? '71px' : '32px'
  const className = `header-page-${pageName}`

  return (
    <header id="header" className={className}>
      <div className="logo-container">
        <div className={'back-container' + (showBack ? '' : ' hidden')}>
          <Less onClick={back} />
        </div>
        <img src={currentLogo.src} style={{ width: logoWidth }} alt="logo" loading="lazy" />
      </div>

      <div className={'progress-bar-wrapper' + (isShow ? '' : ' hidden')}>
        <div className="progress-bar">
          <div className="progress" style={{ width: `${currentPageConfig?.progress}%` }}></div>
        </div>
        <div className={'step-container' + (isShow ? '' : ' hidden')}>
          <span>{currentPageConfig?.pageNumber}</span>/{totalStep}
        </div>
      </div>
    </header>
  )
}
